import { ReactiveMap } from "@solid-primitives/map"
import type { EntityGraphNode } from "../../lib/core/engine/EntityGraphNode/EntityGraphNode.type"
import type { EntityLayerId } from "../../lib/core/entity/EntityLayerId/EntityLayerId.enum"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export type EntityByLayerIdReactiveMap = ReactiveMap<EntityLayerId, Array<EntityGraphNode>>

export const useEntityByLayerIdReactiveMap = createSharedCachedFactory((
  // engine: Engine
): EntityByLayerIdReactiveMap => {
  const map = new ReactiveMap<EntityLayerId, Array<EntityGraphNode>>()
  return map
})
